module.exports = __webpack_public_path__ + "img/alura_badge_01.e82798b2.png";